function offset(el) {
  var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

const body = document.querySelector('body');

const mixin = {
  data: () => ({
    tooltipData: null,
    tooltipOffset: { x: 0, y: 0 },
    tooltipStyles: {
      left: 0 + 'px',
      top: 0 + 'px'
    },
    isZooming: false,
    isApp: Boolean(window.DNA_APP_ENV) || (body && body.attributes && body.attributes.length === 0) || document.querySelector('.screenkit--embed-container'),
    TOUCH_DEVICE: false
  }),

  methods: {
    showTooltip(district, e) {
      if (!this.tooltip) return;
      if (this.isMap && this.isZooming) return;
      if (e.type === 'mouseenter' && 'ontouchstart' in window) return false;

      if (!this.tooltip) {
        this.assignTooltipEl();
      }

      clearTimeout(this.tooltipTimeout);
      this.tooltipData = district;
      this.tooltip.classList.add('visible');

      if (this.isApp) {
        this.tooltip.classList.add('isH20App');
      }

      this.moveTooltip(district, e);
    },
    getTouchOffsets(isMobile, e) {
      if (this.isApp) return {
        left: 0,
        top: 0, //(window.screen.height / 2),
      };

      if (isMobile) {
        return {
          left: e.clientX,
          top: e.clientY - (window.innerHeight / 2)
        };
      }

      return {
        left: 0,
        top: 0,
      };
    },
    moveTooltip(district, e) {
      if (!this.tooltip) return;
      if (this.isMap && this.isZooming) return;
      if (this.isMap && !this.isZooming && district && !this.districtData) this.showTooltip(district, e);
      // get offset from parent container
      const containerOffset = offset(this.$el);
      // determine if mobile / tablet
      const mq = window.matchMedia('screen and (max-width: 979px)');
      // calculate touch offsets
      const touchOffsets = this.getTouchOffsets(mq.matches, e);
      // calculate if the tooltip is going off the screen
      const offScreenX = !mq.matches && ((e.pageX + this.tooltip.offsetWidth) > window.innerWidth) ? true : false;
      const offScreenY = !mq.matches && ((e.pageY + this.tooltip.offsetHeight) > window.innerHeight) ? true : false;

      const classListMethodX = offScreenX ? 'add' : 'remove';
      const classListMethodY = offScreenY ? 'add' : 'remove';

      this.tooltip?.classList[classListMethodX]('flipX');
      this.tooltip?.classList[classListMethodY]('flipY');

      if (this.isApp) {
        // const boundingClient = e.target && e.target.getBoundingClientRect();
        // const clientRects = e.target && e.target.getClientRects();


        // console.log('this.isApp', e.pageY, window.scrollY, window.innerHeight, window.screen.height, containerOffset, e, e.currentTarget, boundingClient, clientRects);
        this.tooltip.style.left = '0%';
        this.tooltip.style.top = (e.pageY - containerOffset.top - touchOffsets.top) + this.tooltipOffset.y + 'px';

        // screen height - app bar - footer bar - electorate header height
        this.tooltip.style['--screen-height'] = window.screen.height + 'px';

      } else {
        this.tooltip.style.left = (e.pageX - containerOffset.left - touchOffsets.left) + this.tooltipOffset.x + 'px';
        this.tooltip.style.top = (e.pageY - containerOffset.top - touchOffsets.top) + this.tooltipOffset.y + 'px';
      }
    },
    hideTooltip(e = {}) {
      if (e.type === 'mouseleave' && ('ontouchstart' in window || (e.sourceCapabilities || {}).firesTouchEvents )) return false;

      this.tooltipTimeout = setTimeout(() => {
        this.tooltip && this.tooltip.classList.remove('visible');
        this.tooltipData = null;
      }, 5);

    },
    assignTooltipEl() {
      this.tooltip = this.$el?.querySelector('.tooltip');
      console.log('tooltip', this.$el, this.$el?.querySelector('.tooltip'));
    }
  },
  mounted() {
    this.assignTooltipEl();

    try {
      document.createEvent('TouchEvent');
      this.TOUCH_DEVICE = true;
    } catch (e) {
      this.TOUCH_DEVICE = false;
    }
  }
};

export default mixin;
